module.exports = "/images/vendor/flag-icon-css/flags/1x1/bo.svg?eab17936c2d9dd56edd3f134c8e6f29c";